module.exports = __webpack_public_path__ + "img/popup7.31baac59.png";